










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator'
import ProductForm from '@/components/common/ProductForm.vue'
import MediaPopup from '@/components/common/MediaPopup.vue'
import CreateLinkPopup from '@/components/Brand/CreateLinkPopup.vue'
import DatePicker from 'vue2-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

  @Component({
    components: {
      ProductForm,
      MediaPopup,
      CreateLinkPopup,
      DatePicker,
      VuePerfectScrollbar,
      Multiselect
    }
  })
export default class CreatePicklPopup extends Vue {
  @Prop() popupId!: string
  @Prop() brandId!: number
  @Prop() OnBoarded!: number
  @Prop() LoadingBrand!: boolean
  @Prop() surveyFeatureAvailable!: boolean
  @Prop() localPicklFeature!: boolean
  @Prop() maxActivities!: number
  @Prop() demographicsFilterFeature!: boolean

  @Prop() selfieFeatureAvailable!: boolean
  @Prop() multiTaskFeature!: boolean
  @Prop() reimbursementFeature!: boolean
  @Prop() couponFeature!: boolean
  @Prop() geoPicklFeature!: boolean

  public : string = ''
  public products: any = []
  public productLimitPerPage: number = 100
  public productOffset: number = 0
  public media: any[] = []
  public mediaLimitPerPage: number = 100
  public mediaOffset: number = 0
  public stores: any = []
  public storeLimitPerPage: number = 1500
  public storeOffset: number = 0
  public step: number = 1
  public showProductForm: boolean = false
  public categories = []
  public tasks: any = []
  public selectedRetails: any = []
  public productImages:any = []
  public selectedStates: any = []
  public allRetailers: any[] =[]
  public filters: any[] = [
    // {
    //   key: 'gender', label: 'Gender'
    // },
    // {
    //   key: 'age_group', label: 'Age Group'
    // },
    {
      key: 'ethnic_background', label: 'Ethnic Background'
    }
    // {
    //   key: 'pets', label: 'Pets'
    // },
    // {
    //   key: 'children', label: 'Children'
    // },
    // {
    //   key: 'language', label: 'Language'
    // }
  ]
  public filterOptions: any =
    {
      'gender': ['Male', 'Female', 'Non-Binary'],

      'age_group': ['18-24', '25-34', '35-44', '45-54', '55-64', '65-80'],

      'ethnic_background': ['Multiracial/Mixed', 'Hispanic/LATAM', 'African American/Black',
        'White', 'Asian or Pacific Islander', 'Middle Eastern', 'Native American/Other'],

      'pets': ['Dog', 'Cat', 'Bird/Small Animal', 'Reptile/Other', 'No Pets'],

      'children': ['1 child', '2 children', '3 or more children', 'No children'],

      'language': ['English', 'Spanish', 'German', 'French', 'Hebrew'],

      '': []
    }

  public pickl: any = {
    credits: '',
    launchType: 'retailer-specific-location',
    campaignName: '',
    unlockCode: '',
    pickl_multiple_products: 0,
    coupon_id: '',
    survey_id: '',
    start_date_time: '',
    task_ids: [],
    location_ids: [],
    immediate_start: false,
    description: '',
    autoExtend: false,
    extendCounter: 0,
    launchArea: '',
    extendDays: 0,
    takeSelfie: 0,
    multipleResponses: 0,
    responseCounter: '',
    hasReimbursement: 0,
    reimbursementCredits: 0,
    countryId: 234,
    location: '',
    maxTasksPerUser: '',
    selectedRetailerId: '',
    selectedStateIds: [],
    selectedCityIds: [],
    activityType: '',
    mediaId: '',
    videoDescription: '',
    products: [
      {
        product_id: '',
        description: '',
        task_ids: []
      }
    ],

    filters: [
      {
        type: '',
        values: []
      }
    ]
  }
  public filter: any = {
    type: '',
    value: ''
  }
  public selectedStores: any[] = []
  public selectAll: boolean = false
  public citiesSelectAll: boolean = false
  public showLimitError: boolean = false
  public storeName: string = ''
  public storeCity: string = ''
  public storeZipCode: string = ''
  public storeState: string = ''
  public taskLimitPerPage: number = 100
  public taskOffset: number = 0
  public submittingForm = false
  public val: any = ''
  public date: Date = new Date()
  public time: Date = new Date()
  public settings: any = {}
  public loadingCredits: boolean = true
  public busy: boolean = false
  public lowSrcQuery: string = '?w=300&q=100&fit=crop'
  public states: [] = []
  public cities: [] = []
  public stateId: string = ''
  public countryId: number = 234
  public retailers: [] = []
  public storeId: string = ''
  public countries: [] = []
  public duplicatePicklErrorMessage: string = ''

  public limit = 100
  public offset = 0
  public actionSurvey: any = null
  public surveys: any[] = []
  public totalCount = 0
  public locationCatalogues:any[] =[]
  public maxExtendDays: any[] = []
  public maxExtendCounter: any[] = []
  public showSurveyField: boolean = false
  public surveyUnavailableMessage: string = ''
  public limitPerPage:number = 100
  public surveysOffset:number = 0
  public selectedLocationCatalogue:number = 0
  public CatalogueSelectedStoreLocations: any[] = []
  public reimbursementCredits:number = 0
  public brandCoupons: any = []
  public StepTwoErrors: boolean = false
  public duplicatePicklLocationIds: any[] = []
  public hasRetailerStore : boolean = false
  public userRole: String = ''
  public launchedCampaignSummary: any = null
  public selectedCities: any = []
  public geoRestricted: boolean = false
  public activityTypes: any[] = []
  public currentActivityType: string = ''
  public manuallyToggledActivities: Set<number> = new Set()
  public activelyEditingActivities: Set<number> = new Set()
  public draggedIndex: number = -1
  public dragOverIndex: number = -1
  public brandLinks: any[] = []
  public tags: string[] = [
    'CPG',
    'Retail',
    'Grocery',
    'Airport',
    'Restaurant',
    'Event',
    'QSR',
    'Movie Theatre',
    'Festival',
    'Sports'
  ]

  get retailTasks () {
    return this.tasks.filter((task: any) => task.tags && task.tags.includes('Retail'))
  }
  get diningTasks () {
    return this.tasks.filter((task: any) => task.tags && task.tags.includes('Dining'))
  }
  get entertainmentTasks () {
    return this.tasks.filter((task: any) => task.tags && task.tags.includes('Entertainment'))
  }
  get eventsTasks () {
    return this.tasks.filter((task: any) => task.tags && task.tags.includes('Events'))
  }
  get hospitalityTasks () {
    return this.tasks.filter((task: any) => task.tags && task.tags.includes('Hospitality'))
  }

  get checkIfStateRetailerSelected () {
    if (this.stateId !== '' && this.storeId !== '') {
      return true
    } else {
      return false
    }
  }

  get creditsLeft () {
    let credits = 0
    if (this.pickl.multipleResponses === true) {
      credits = this.$store.state.brandCreditsRemaining - this.selectedRetails.length * this.pickl.responseCounter
    } else {
      credits = this.$store.state.brandCreditsRemaining - this.selectedRetails.length
    }

    return credits
  }

  get isProductTaskSelectionValid () {
    if (this.pickl.activityType !== 'product') {
      return true
    }
    if (this.pickl.products.length === 0) {
      return false
    }
    for (let i = 0; i < this.pickl.products.length; i++) {
      const product = this.pickl.products[i]
      if (!product.product_id || product.product_id === '') {
        return false
      }
      if (!product.task_ids || product.task_ids.length === 0) {
        return false
      }
    }
    return true
  }

  get areAllActivityTypesValid () {
    if (this.activityTypes.length === 0) {
      return false
    }
    for (let i = 0; i < this.activityTypes.length; i++) {
      const activity = this.activityTypes[i]
      if (activity.type === 'product') {
        if (!activity.config.products || activity.config.products.length === 0) {
          return false
        }
        for (let j = 0; j < activity.config.products.length; j++) {
          const product = activity.config.products[j]
          if (!product.product_id || product.product_id === '') {
            return false
          }
          if (!product.task_ids || product.task_ids.length === 0) {
            return false
          }
        }
      } else if (activity.type === 'photo') {
        if (!activity.config.task_ids || activity.config.task_ids.length === 0) {
          return false
        }
      } else if (activity.type === 'video') {
        if (!activity.config.videoDescription || activity.config.videoDescription.trim() === '') {
          return false
        }
      } else if (activity.type === 'survey') {
        if (!activity.config.survey_id || activity.config.survey_id === '') {
          return false
        }
      } else if (activity.type === 'buy-me') {
        if (!activity.config.reimbursementCredits || activity.config.reimbursementCredits === '') {
          return false
        }
      } else if (activity.type === 'deal-drop') {
        if (!activity.config.couponId || activity.config.couponId === '') {
          return false
        }
      } else if (activity.type === 'watch') {
        if (!activity.config.youtubeUrl || activity.config.youtubeUrl.trim() === '') {
          return false
        }
        if (!this.isValidUrl(activity.config.youtubeUrl)) {
          return false
        }
        if (!activity.config.description || activity.config.description.trim() === '') {
          return false
        }
      } else if (activity.type === 'url-visit') {
        if (!activity.config.url || activity.config.url.trim() === '') {
          return false
        }
        if (!this.isValidUrl(activity.config.url)) {
          return false
        }
        if (!activity.config.description || activity.config.description.trim() === '') {
          return false
        }
      } else if (activity.type === 'app-install') {
        if (!activity.config.link_id) {
          return false
        }
      } else if (activity.type === 'review') {
        if (!activity.config.link_id) {
          return false
        }
      }
    }
    return true
  }
  get counterDropDownList () {
    let totalCreditsleft = this.$store.state.brandCreditsRemaining
    let counterList = [2, 3, 4]
    let counter = 0
    let incrementValue = 5
    while (counter <= totalCreditsleft) {
      if (counter >= 50) {
        incrementValue = 25
      }
      if (counter >= 300) {
        incrementValue = 100
      }
      counter = counter + incrementValue
      if (counter <= totalCreditsleft) {
        counterList.push(counter)
      }
    }
    return counterList
  }

  get counterReimbursementDropDownList () {
    let totalCreditsleft = this.reimbursementCredits
    let counterList = []
    let counter = 0
    let incrementValue = 1
    while (counter <= totalCreditsleft) {
      if (counter >= 5) {
        incrementValue = 5
      }
      counter = counter + incrementValue
      if (counter <= totalCreditsleft) {
        counterList.push(counter)
      }
      if (counter === 5) {
        break
      }
    }
    return counterList
  }
  removeFilter (index: number) {
    this.pickl.filters.splice(index, 1)
  }
  addMoreFilter () {
    this.pickl.filters.push(
      {
        type: '',
        values: []
      }
    )
  }
  getStateCities () {
    this.$store.dispatch('getStateCities', { stateId: this.stateId }).then((response: any) => {
      this.cities = response.response.body
    })
  }

  makeSelectedFilterOptionsEmpty (index: number) {
    this.pickl.filters[index].values = []
  }

  setProductImage (productId:number, index:number) {
    console.log()
    this.products.forEach((product: any) => {
      if (product.id === productId) {
        this.productImages[index] = product.image
      }
    })
  }
  inSelectedStatesList (store: any) {
    let isObjectPresent = this.selectedStates.find((o:any) => o.id === store.id)
    if (typeof isObjectPresent !== 'undefined') {
      return true
    } else {
      return false
    }
  }

  inSelectedCitiesList (city: any) {
    let isObjectPresent = this.selectedCities.find((o:any) => o.id === city.id)
    if (typeof isObjectPresent !== 'undefined') {
      return true
    } else {
      return false
    }
  }

  addProductToPickl () {
    this.pickl.products.push(
      {
        product_id: '',
        description: '',
        task_ids: []
      }
    )
  }

  step1 () {
    if (!this.pickl.immediate_start) {
      let dateTime = this.date
      dateTime.setHours(this.time.getHours(), 0, 0)
      if (new Date().getTime() > dateTime.getTime()) {
        this.$notify({ text: 'Start Date time should be later than current time', type: 'error' })
        return false
      }
      this.pickl.start_date_time = dateTime.getTime() / 1000
    }
    // Basic validation for step 1
    if (!this.pickl.campaignName || this.pickl.campaignName.trim() === '') {
      this.$notify({ text: 'Please enter a campaign name', type: 'error' })
      return false
    }
    this.$validator.validateAll('mix-campaign-form').then((result) => {
      if (result) {
        this.step = 2
      }
    })
  }
  step2 () {
    // Validate activity types
    if (this.activityTypes.length === 0) {
      this.$notify({ text: 'Please add at least one activity type', type: 'error' })
      return false
    }

    // Validate each activity type
    for (let i = 0; i < this.activityTypes.length; i++) {
      const activity = this.activityTypes[i]

      if (activity.type === 'product') {
        if (!activity.config.products || activity.config.products.length === 0) {
          this.$notify({ text: `Activity ${i + 1}: Please add at least one product`, type: 'error' })
          return false
        }
        let multipleProductsSelected = activity.config.products.length > 1
        activity.config.products.forEach((product: any, pIndex: number) => {
          if (product.product_id === '') {
            this.$notify({ text: `Activity ${i + 1}: Please select a product for Product ${pIndex + 1}`, type: 'error' })
            return false
          }
          if (product.task_ids.length === 0) {
            this.$notify({ text: `Activity ${i + 1}: Please select task images for Product ${pIndex + 1}`, type: 'error' })
            return false
          }
          const maxTasks = multipleProductsSelected
            ? ((this.$store.state.settings && this.$store.state.settings.max_tasks_per_product) || 10)
            : ((this.$store.state.settings && this.$store.state.settings.max_tasks_per_pickl) || 20)
          if (product.task_ids.length > maxTasks) {
            this.$notify({
              text: `Activity ${i + 1}: You can select max ${maxTasks} task images for Product ${pIndex + 1}`,
              type: 'error'
            })
            return false
          }
        })
      } else if (activity.type === 'photo') {
        if (!activity.config.task_ids || activity.config.task_ids.length === 0) {
          this.$notify({ text: `Activity ${i + 1}: Please select at least one task image`, type: 'error' })
          return false
        }
        const maxTasks = (this.$store.state.settings && this.$store.state.settings.max_tasks_per_pickl) || 20
        if (activity.config.task_ids.length > maxTasks) {
          this.$notify({
            text: `Activity ${i + 1}: You can select max ${maxTasks} task images`,
            type: 'error'
          })
          return false
        }
      } else if (activity.type === 'video') {
        if (!activity.config.videoDescription || activity.config.videoDescription.trim() === '') {
          this.$notify({ text: `Activity ${i + 1}: Please enter a description for the video recording location`, type: 'error' })
          return false
        }
      } else if (activity.type === 'selfie') {
        if (!activity.config.selfieDescription || activity.config.selfieDescription.trim() === '') {
          this.$notify({ text: `Activity ${i + 1}: Please enter a description for the selfie activity`, type: 'error' })
          return false
        }
      } else if (activity.type === 'survey') {
        if (!activity.config.survey_id || activity.config.survey_id === '') {
          this.$notify({ text: `Activity ${i + 1}: Please select a survey`, type: 'error' })
          return false
        }
      } else if (activity.type === 'buy-me') {
        // if (!activity.config.description || activity.config.description.trim() === '') {
        //   this.$notify({ text: `Activity ${i + 1}: Please enter a description for Buy Me Activity`, type: 'error' })
        //   return false
        // }
        if (!activity.config.reimbursementCredits || activity.config.reimbursementCredits === '') {
          this.$notify({ text: `Activity ${i + 1}: Please select reimbursement credits for Buy Me Activity`, type: 'error' })
          return false
        }
      } else if (activity.type === 'deal-drop') {
        // if (!activity.config.description || activity.config.description.trim() === '') {
        //   this.$notify({ text: `Activity ${i + 1}: Please enter a description for Deal Drop`, type: 'error' })
        //   return false
        // }
        if (!activity.config.couponId || activity.config.couponId === '') {
          this.$notify({ text: `Activity ${i + 1}: Please select a coupon for Deal Drop`, type: 'error' })
          return false
        }
      } else if (activity.type === 'watch') {
        if (!activity.config.youtubeUrl || activity.config.youtubeUrl.trim() === '') {
          this.$notify({ text: `Activity ${i + 1}: Please enter a YouTube URL for Watch Activity`, type: 'error' })
          return false
        }
        if (!this.isValidUrl(activity.config.youtubeUrl)) {
          this.$notify({ text: `Activity ${i + 1}: Please enter a valid YouTube URL (must start with http:// or https://)`, type: 'error' })
          return false
        }
        if (!activity.config.description || activity.config.description.trim() === '') {
          this.$notify({ text: `Activity ${i + 1}: Please enter a description for Watch Activity`, type: 'error' })
          return false
        }
      } else if (activity.type === 'url-visit') {
        if (!activity.config.url || activity.config.url.trim() === '') {
          this.$notify({ text: `Activity ${i + 1}: Please enter a URL for URL Visit Activity`, type: 'error' })
          return false
        }
        if (!this.isValidUrl(activity.config.url)) {
          this.$notify({ text: `Activity ${i + 1}: Please enter a valid URL (must start with http:// or https://)`, type: 'error' })
          return false
        }
        if (!activity.config.description || activity.config.description.trim() === '') {
          this.$notify({ text: `Activity ${i + 1}: Please enter a description for URL Visit Activity`, type: 'error' })
          return false
        }
      } else if (activity.type === 'app-install') {
        if (!activity.config.link_id) {
          this.$notify({ text: `Activity ${i + 1}: Please select a link for App Install Activity`, type: 'error' })
          return false
        }
      } else if (activity.type === 'review') {
        if (!activity.config.link_id) {
          this.$notify({ text: `Activity ${i + 1}: Please select a link for Review Activity`, type: 'error' })
          return false
        }
      }
    }

    // Move to step 3 (sort activities)
    this.step = 3
  }

  step3 () {
    // Validate that activities exist (should already be validated in step2)
    if (this.activityTypes.length === 0) {
      this.$notify({ text: 'Please add at least one activity type', type: 'error' })
      return false
    }
    // Move to step 4 (location selection)
    this.step = 4
  }

  step4 () {
    // Validate location selection
    if (this.pickl.geoRestricted === 1) {
      // Geo restricted: need to select stores
      if (this.selectedRetails.length === 0) {
        this.$notify({ text: 'Please select at least one store location', type: 'error' })
        return false
      }
    } else {
      // Non-geo restricted: need launch area and location selection (retailer is optional)
      if (!this.pickl.launchArea || this.pickl.launchArea.trim() === '') {
        this.$notify({ text: 'Please select a launch area', type: 'error' })
        return false
      }
      if (!this.pickl.responseCounter || this.pickl.responseCounter === '') {
        this.$notify({ text: 'Please select total activity count', type: 'error' })
        return false
      }
      if (this.pickl.launchArea === 'cities') {
        if (this.selectedCities.length === 0) {
          this.$notify({ text: 'Please select at least one city', type: 'error' })
          return false
        }
      } else {
        if (this.selectedStates.length === 0) {
          this.$notify({ text: 'Please select at least one state', type: 'error' })
          return false
        }
      }
    }

    // Submit the mix campaign
    this.createMixCampaign()
  }

  get isLocationSelectionValid () {
    if (this.pickl.geoRestricted === 1) {
      return this.selectedRetails.length > 0
    } else {
      if (!this.pickl.launchArea || this.pickl.launchArea.trim() === '') {
        return false
      }
      if (!this.pickl.responseCounter || this.pickl.responseCounter === '') {
        return false
      }
      if (this.pickl.launchArea === 'cities') {
        return this.selectedCities.length > 0
      } else {
        return this.selectedStates.length > 0
      }
    }
  }

  createMixCampaign () {
    this.submittingForm = true
    this.$store.commit('showLoading')

    // Prepare location data
    this.pickl.location_ids = []
    if (this.pickl.geoRestricted === 1) {
      this.selectedRetails.forEach((x: any) => {
        this.pickl.location_ids.push(x.id)
      })
    } else {
      // Non-geo restricted: set selected state or city IDs based on launch area
      if (this.pickl.launchArea === 'cities') {
        this.pickl.selectedCityIds = this.selectedCities.map((city: any) => city.id)
      } else {
        this.pickl.selectedStateIds = this.selectedStates.map((state: any) => state.id)
      }
    }

    // Prepare activity types: for review/app-install send only link_id in config
    const activityTypesForPayload = this.activityTypes.map((activity: any) => {
      if (activity.type === 'review' || activity.type === 'app-install') {
        const linkId = activity.config.link_id
        return {
          type: activity.type,
          config: { link_id: linkId ? Number(linkId) || linkId : null },
          collapsed: activity.collapsed
        }
      }
      return activity
    })

    // Prepare the mix campaign data
    const mixCampaignData: any = {
      campaignName: this.pickl.campaignName,
      unlockCode: this.pickl.unlockCode,
      start_date_time: this.pickl.start_date_time,
      immediate_start: this.pickl.immediate_start,
      description: this.pickl.description,
      autoExtend: this.pickl.autoExtend,
      extendCounter: this.pickl.extendCounter,
      extendDays: this.pickl.extendDays,
      activityTypes: activityTypesForPayload,
      geoRestricted: this.pickl.geoRestricted,
      countryId: this.pickl.countryId
    }

    // Add location-specific data based on geo restriction
    if (this.pickl.geoRestricted === 1) {
      mixCampaignData.location_ids = this.pickl.location_ids
    } else {
      mixCampaignData.launchArea = this.pickl.launchArea
      // Only include selectedRetailerId if it's provided (optional)
      if (this.pickl.selectedRetailerId && this.pickl.selectedRetailerId !== '') {
        mixCampaignData.selectedRetailerId = this.pickl.selectedRetailerId
      }
      mixCampaignData.maxTasksPerUser = this.pickl.maxTasksPerUser
      mixCampaignData.responseCounter = this.pickl.responseCounter
      mixCampaignData.credits = this.pickl.credits
      if (this.pickl.launchArea === 'cities') {
        mixCampaignData.selectedCityIds = this.pickl.selectedCityIds
      } else {
        mixCampaignData.selectedStateIds = this.pickl.selectedStateIds
      }
    }

    // Call create-mix-campaign API
    this.$http.post(`brands/${this.brandId}/create-mix-campaign`, mixCampaignData, {
      headers: {
        'user-type': 'brand'
      }
    }).then((response: any) => {
      this.$emit('UpdatePicklList')
      this.$notify({ type: 'success', text: 'Mix campaign has been created successfully!' })
      this.submittingForm = false
      this.$store.commit('hideMessage')

      let locationNames = ''
      if (this.pickl.geoRestricted !== 1) {
        if (this.pickl.launchArea === 'cities') {
          locationNames = this.selectedCities.map((c: any) => c.name).join(', ')
        } else {
          locationNames = this.selectedStates.map((s: any) => s.name).join(', ')
        }
      }

      this.launchedCampaignSummary = {
        campaignName: this.pickl.campaignName,
        unlockCode: this.pickl.unlockCode,
        start_date_time: this.pickl.start_date_time,
        immediate_start: this.pickl.immediate_start,
        description: this.pickl.description,
        autoExtend: this.pickl.autoExtend,
        extendCounter: this.pickl.extendCounter,
        extendDays: this.pickl.extendDays,
        activities: this.activityTypes.map((a: any) => ({ type: a.type })),
        geoRestricted: this.pickl.geoRestricted === 1,
        locationCount: this.selectedRetails.length,
        launchArea: this.pickl.launchArea,
        locationNames: locationNames,
        responseCounter: this.pickl.responseCounter,
        credits: this.pickl.credits,
        campaignId: response.body && response.body.id ? response.body.id : null
      }

      this.step = 5
    }, (response: any) => {
      // Handle error response
      if (response.body && response.body.message) {
        this.$notify({ type: 'error', text: response.body.message })
      } else if (response.body && typeof response.body === 'object') {
        // Handle validation errors
        for (const key in response.body) {
          if (Array.isArray(response.body[key]) && response.body[key].length > 0) {
            this.$notify({ type: 'error', text: response.body[key][0] })
            break
          }
        }
      } else {
        this.$notify({ type: 'error', text: 'Failed to create mix campaign. Please try again.' })
      }
      this.submittingForm = false
      this.$store.commit('hideMessage')
    })
  }

  resetForm () {
    this.step = 1
    this.launchedCampaignSummary = null
    this.pickl.campaignName = ''
    this.pickl.unlockCode = ''
    this.pickl.description = ''
    this.pickl.immediate_start = false
    this.pickl.autoExtend = false
    this.pickl.extendCounter = 0
    this.pickl.extendDays = 0
    this.pickl.activityType = ''
    this.pickl.task_ids = []
    this.pickl.mediaId = ''
    this.pickl.videoDescription = ''
    this.pickl.survey_id = ''
    this.pickl.geoRestricted = 0
    this.geoRestricted = false
    this.activityTypes = []
    this.currentActivityType = ''
    this.manuallyToggledActivities = new Set()
    this.activelyEditingActivities = new Set()
    this.selectedRetails = []
    this.selectedStates = []
    this.selectedCities = []
    this.pickl.location_ids = []
    this.pickl.location = ''
    this.pickl.selectedStateIds = []
    this.pickl.maxTasksPerUser = ''
    this.pickl.responseCounter = ''
    this.pickl.countryId = 234
    this.stateId = ''
    this.storeId = ''
    this.storeCity = ''
    this.storeZipCode = ''
    this.stores = []
    this.states = []
    this.retailers = []
    this.selectAll = false
    this.citiesSelectAll = false
    this.date = new Date()
    this.time = new Date()
    this.time.setHours(this.time.getHours() + 1)
  }

  goToPicklsListing () {
    const closeButton: HTMLElement = this.$refs.closeCreatePicklPopupButton as HTMLElement
    if (closeButton) {
      closeButton.click()
    }

    const campaignId = this.launchedCampaignSummary ? this.launchedCampaignSummary.campaignId : null
    const isGeo = this.launchedCampaignSummary ? this.launchedCampaignSummary.geoRestricted : false

    if (this.userRole === 'super-admin') {
      if (campaignId) {
        this.$router.push(`/sadmin/campaigns/${campaignId}/pickls`)
      } else {
        this.$router.push(isGeo ? '/sadmin/pickls' : '/sadmin/non-geo-pickls')
      }
    } else if (this.userRole === 'staff') {
      this.$router.push(isGeo ? '/staff/pickls' : '/staff/non-geo-pickls')
    } else {
      if (campaignId) {
        this.$router.push(`/brand/campaigns/${campaignId}/pickls`)
      } else {
        this.$router.push(isGeo ? '/brand/pickl-history' : '/brand/non-geo-pickl-history')
      }
    }

    this.resetForm()
    this.launchedCampaignSummary = null
  }

  closeSummaryAndReset () {
    this.resetForm()
    this.launchedCampaignSummary = null
  }

  getCatalogueStoreLocations () {
    this.$store.dispatch('getCatalogueStoreLocations', { brandId: this.brandId, locationCatalogueId: this.selectedLocationCatalogue }).then((response: any) => {
      this.CatalogueSelectedStoreLocations = response.response.body.locations
      this.stores = []
      console.log(this.CatalogueSelectedStoreLocations)
      this.CatalogueSelectedStoreLocations.forEach((catalogue: any) => {
        this.stores.push(catalogue.store_location)
      })
      this.selectAll = true
      this.onSelectAll(false)
    })
  }

  get checkGoPicklValidation () {
    if (this.pickl.launchType === 'retailer-specific-location') {
      if (this.selectedRetails.length === 0) {
        return true
      }
      if (this.pickl.multipleResponsegxs === true && this.pickl.responseCounter === '') {
        return true
      }
    }
    if (this.pickl.launchType === 'retailer-any-location') {
      if (this.pickl.launchArea === 'cities') {
        if (this.selectedCities.length === 0 || this.pickl.selectedRetailerId === '' || this.pickl.responseCounter === '') {
          return true
        }
      } else {
        if (this.selectedStates.length === 0 || this.pickl.selectedRetailerId === '' || this.pickl.responseCounter === '') {
          return true
        }
      }
    }
    if (this.pickl.launchType === 'global-any-location') {
      if (this.pickl.location === '') {
        return true
      }
      if (this.selectedStates.length === 0) {
        return true
      }
    }
    return false
  }
  addProduct () {
    this.busy = true;
    (this.$refs.productForm as ProductForm).addProduct()
  }

  setSelected (store: any, selected: boolean) {
    // if (this.pickl.multipleResponses === true) {
    //   if (this.selectedRetails.length === 1) {
    //     this.$notify({ text: 'Multi responses task can be launched at one location at a time!', type: 'error' })
    //     return false
    //   }
    // }
    if (this.creditsLeft === 0) {
      this.$notify({ text: 'You\'ve reached your maximum credits', type: 'error' })
      return false
    }
    let isObjectPresent = this.selectedRetails.findIndex((o:any) => o.id === store.id)
    if (isObjectPresent === -1) {
      this.selectedRetails.push({ id: store.id, name: store.store.name, address: store.address, image: store.store.image })
    } else {
      this.selectedRetails.splice(isObjectPresent, 1)
    }
  }
  setStateSelected (state: any, selected: boolean) {
    let isObjectPresent = this.selectedStates.findIndex((o:any) => o.id === state.id)
    if (isObjectPresent === -1) {
      this.selectedStates.push({ id: state.id, name: state.name })
    } else {
      this.selectedStates.splice(isObjectPresent, 1)
    }
  }
  setCitySelected (city: any, selected: boolean) {
    let isObjectPresent = this.selectedCities.findIndex((o:any) => o.id === city.id)
    if (isObjectPresent === -1) {
      this.selectedCities.push({ id: city.id, name: city.name })
    } else {
      this.selectedCities.splice(isObjectPresent, 1)
    }
  }
  getBrandLocationCatalogues () {
    this.$store.dispatch('getLocationCatalogueList', { query: '', limit: this.limit, offset: this.offset, brand_id: this.brandId }).then((response) => {
      if (response.options.limit === this.limit && this.offset === response.options.offset) {
        this.locationCatalogues.push(...response.response.body.locationCatalogues)
      }
    }, (response) => {
      this.busy = false
    })
  }

  getBrandLinks () {
    if (!this.brandId) return
    this.$http.get(`brands/${this.brandId}/links`).then((response: any) => {
      const body = response.body || {}
      this.brandLinks = Array.isArray(body.data) ? body.data : (Array.isArray(body.links) ? body.links : [])
    }, () => {
      this.brandLinks = []
    })
  }

  getBrandLinksByType (linkType: string) {
    return this.brandLinks.filter((l: any) => (l.link_type || '') === linkType)
  }

  onBrandLinkSelectForActivity (activityIndex: number, linkType: string, linkId: string) {
    if (!this.activityTypes[activityIndex]) return
    this.activityTypes[activityIndex].config.link_id = linkId || null
  }

  onLinkCreatedFromMix () {
    this.getBrandLinks()
  }

  @Watch('step')
  onStepChange () {
    if (this.step === 2 && this.brandId) {
      this.getBrandLinks()
    }
    // Load location catalogues when entering step 3
    if (this.step === 3 && this.locationCatalogues.length === 0) {
      this.getBrandLocationCatalogues()
    }
  }

  inSelectedStoresList (store: any) {
    let isObjectPresent = this.selectedRetails.find((o:any) => o.id === store.id)
    if (typeof isObjectPresent !== 'undefined') {
      return true
    } else {
      return false
    }
  }

  removeRetailer (index: number) {
    this.selectedRetails.splice(index, 1)
  }
  removeCity (index: number) {
    this.selectedCities.splice(index, 1)
  }
  removeState (index: number) {
    this.selectedStates.splice(index, 1)
  }

  onSelectAllState (event: any) {
    if (this.selectAll) {
      this.states.forEach((state: any) => {
        let isObjectPresent = this.selectedStates.find((o:any) => o.id === state.id)
        if (typeof isObjectPresent !== 'undefined') {
          return false
        }
        this.selectedStates.push({ id: state.id, name: state.name })
      })
    } else {
      this.states.forEach((state: any) => {
        let selectedStateIndex = this.selectedStates.findIndex((o:any) => o.id === state.id)
        if (selectedStateIndex !== -1) {
          this.removeRetailer(selectedStateIndex)
        }
      })
    }
  }
  onSelectAllCities (event: any) {
    if (this.citiesSelectAll) {
      this.cities.forEach((city: any) => {
        let isObjectPresent = this.selectedCities.find((o:any) => o.id === city.id)
        if (typeof isObjectPresent !== 'undefined') {
          return false
        }
        this.selectedCities.push({ id: city.id, name: city.name })
      })
    } else {
      this.cities.forEach((city: any) => {
        let selectedCityIndex = this.selectedCities.findIndex((o:any) => o.id === city.id)
        if (selectedCityIndex !== -1) {
          this.removeCity(selectedCityIndex)
        }
      })
    }
  }

  onSelectAll (event: any) {
    if (this.selectAll) {
      if (this.creditsLeft < this.updatedStores.length) {
        this.$notify({ text: 'You\'ve reached your maximum credits', type: 'error' })
        return false
      }
      this.updatedStores.forEach((store: any) => {
        let isObjectPresent = this.selectedRetails.find((o:any) => o.id === store.id)
        if (typeof isObjectPresent !== 'undefined') {
          return false
        }
        let selectedRetailerIndex = this.selectedRetails.findIndex((o:any) => o.id === store.id)
        if (selectedRetailerIndex === -1) {
          this.selectedRetails.push({ id: store.id, name: store.store.name, address: store.address, image: store.store.image })
        }
      })
    } else {
      this.updatedStores.forEach((store: any) => {
        let selectedRetailerIndex = this.selectedRetails.findIndex((o:any) => o.id === store.id)
        if (selectedRetailerIndex !== -1) {
          this.removeRetailer(selectedRetailerIndex)
        }
      })
    }
  }
  getTaskList () {
    this.$store.dispatch('getTasks', { limit: this.taskLimitPerPage, offset: this.taskOffset }).then((response: any) => {
      this.tasks.push(...response.response.body.data)
      if (this.tasks.length < response.response.body.count) {
        this.taskOffset += this.taskLimitPerPage
        this.getTaskList()
      }
    })
  }
  removeProductFromPickl (index: number) {
    let elem : any = ''
    elem = document.getElementById('product-link-0')
    elem.click()
    window.scrollTo(0, 0)

    this.pickl.products.splice(index, 1)
  }
  ValidateAndCreatPickl () {
    this.pickl.location_ids = []
    this.selectedRetails.forEach((x: any) => {
      this.pickl.location_ids.push(x.id)
    })

    if (this.pickl.launchType === 'retailer-specific-location' && this.pickl.location_ids.length === 0) {
      this.$notify({ text: 'Please select Stores', type: 'error' })
      return false
    }
    if (this.pickl.multipleResponses === true && this.pickl.responseCounter === '') {
      this.$notify({ text: 'Please select response counter', type: 'error' })
      return false
    }
    this.pickl.product_id = this.pickl.products[0].product_id
    this.pickl.selectedStateIds = this.selectedStates.map((state: any) => state.id)
    this.pickl.selectedCityIds = this.selectedCities.map((state: any) => state.id)
    this.createPickl()
  }
  createPickl () {
    this.submittingForm = true
    this.duplicatePicklErrorMessage = ''
    this.$store.commit('showLoading')
    this.$store.dispatch('addPickl', { brandId: this.brandId, pickl: this.pickl }).then(() => {
      this.$emit('UpdatePicklList')
      // let closeCreatePicklPopupButton: HTMLElement = this.$refs.closeCreatePicklPopupButton as HTMLElement
      // closeCreatePicklPopupButton.click()
      this.$notify({ type: 'success', text: 'PICKL has been created successfully. You want to blast more pickls?' })
      this.submittingForm = false
      this.selectAll = false
      this.storeName = ''
      this.storeCity = ''
      this.storeZipCode = ''
      // this.stores = []
      this.selectedStores = []
      this.selectedRetails = []
      // this.step = 1
      this.onSelectAll(false)
      this.date = new Date()
      this.time = this.date
      this.time.setHours(this.time.getHours() + 1)
      this.$store.commit('showMessage', { message: 'GOOOO PICKL!' })
      this.selectedCities = []
      this.pickl.maxTasksPerUser = ''
      this.pickl.responseCounter = ''
      // this.stateId = ''
      // this.getStoresList()
    }, (response) => {
      for (var key in response.body) {
        if (response.status === 400) {
          // this.$notify({ type: 'error', text: response.body[key][0] })
          this.duplicatePicklErrorMessage = response.body.message
          this.duplicatePicklLocationIds = response.body.locationIds
        } else {
          this.$notify({ type: 'error', text: response.body[key][0] })
        }
        let field = this.$validator.fields.find({ name: key, scope: 'select-product-form' })
        if (field) {
          this.$validator.errors.add({
            id: field.id,
            field: key,
            msg: response.body[key][0],
            scope: 'select-product-form'
          })
        }
      }
      this.submittingForm = false
      this.$store.commit('hideMessage')
    })
  }
  get updatedStores () {
    let filteredStores = this.stores
    if (this.storeName !== '') {
      filteredStores = filteredStores.filter((m: any) => (m.store.name.toLowerCase().search(this.storeName.trim().toLowerCase()) > -1))
    }
    if (this.storeCity !== '') {
      filteredStores = filteredStores.filter((m: any) => (m.state && m.city.toLowerCase().search(this.storeCity.trim().toLowerCase()) > -1))
    }
    if (this.storeState !== '') {
      filteredStores = filteredStores.filter((m: any) => (m.state && m.state.toLowerCase().search(this.storeState.trim().toLowerCase()) > -1))
    }
    if (this.storeZipCode !== '') {
      filteredStores = filteredStores.filter((m: any) => (m.zip_code && m.zip_code.toLowerCase().search(this.storeZipCode.trim().toLowerCase()) > -1))
    }
    for (var i = 0; i < filteredStores.length; ++i) {
      if (this.selectedStores.indexOf(filteredStores[i]) === -1) {
        this.selectAll = false
        break
      } else if (filteredStores.length - 1 === i) this.selectAll = true
    }
    return filteredStores
  }

  removeDuplicateLocations () {
    console.log(this.duplicatePicklLocationIds)
    this.duplicatePicklLocationIds.forEach((id:any) => {
      let isObjectPresent = this.selectedRetails.findIndex((o:any) => o.id === id)
      this.selectedRetails.splice(isObjectPresent, 1)
    })
  }

  refreshProductList () {
    this.busy = false
    this.showProductForm = false
    this.products = []
    this.getProducts()
    this.$emit('refreshProductList')
  }

  refreshMediaList () {
    this.busy = false
    this.media = []
    this.mediaOffset = 0
    this.getMedia()
    this.$emit('refreshMediaList')
  }

  getMedia () {
    this.$store
      .dispatch('getMediaList', {
        limit: this.mediaLimitPerPage,
        offset: this.mediaOffset,
        brand_id: this.brandId
      })
      .then(
        (response: any) => {
          this.media.push(...response.response.body.media)
          if (this.media.length < response.response.body.count) {
            this.mediaOffset += this.mediaLimitPerPage
            this.getMedia()
          }
        },
        (response: any) => {
          this.busy = false
        }
      )
  }

  getProducts () {
    this.$store.dispatch('getBrandProducts', { brandId: this.brandId, limit: this.productLimitPerPage, offset: this.productOffset, sort: 'name-ASC' }).then((response: any) => {
      this.products.push(...response.response.body.data)
      if (this.products.length < response.response.body.count) {
        this.productOffset += this.productLimitPerPage
        this.getProducts()
      }
    })
  }

  getStoreLocations (clear: boolean = true): void {
    this.$store.dispatch('getStoreLocations', { limit: this.storeLimitPerPage, offset: this.storeOffset, sort: 'name-ASC', storeId: this.storeId, stateId: this.stateId, city: this.storeCity, zipCode: this.storeZipCode, showEnabled: 1 }).then((response: any) => {
      this.stores.push(...response.response.body.data)
      if (this.stores.length < response.response.body.count) {
        this.storeOffset += this.storeLimitPerPage
        this.getStoreLocations()
      }
    })
  }

  getCountries () {
    this.$http.get('countries?service_enabled=true').then((response: any) => {
      this.countries = response.body.data
    })
  }

  getStates () {
    this.stateId = ''
    this.stores = []
    this.selectedStores = []
    this.retailers = []
    this.states = []
    this.storeZipCode = ''
    this.storeCity = ''
    this.$store.commit('showLoading', 'Loading States')
    this.$http.get('states?country_id=' + this.pickl.countryId).then((response: any) => {
      this.states = response.body.data
      this.$store.commit('hideMessage')
    })
  }

  getStoresList () {
    this.$store.commit('showLoading', 'Loading Retailers')
    this.storeId = ''
    this.stores = []
    this.selectedStores = []
    this.retailers = []
    this.storeZipCode = ''
    this.storeCity = ''
    if (this.stateId !== '') {
      this.$http.get('stores/get-by-state/' + this.stateId).then((response: any) => {
        this.retailers = response.body.data
        this.$store.commit('hideMessage')
      })
    }
  }

  getAllRetailers () {
    this.$store.dispatch('getStores', { limit: 1000, offset: 0, sort: 'name-ASC' }).then((response: any) => {
      // console.log(response.response.body.data)
      this.allRetailers.push(...response.response.body.data)
    })
  }

  updateStoreHandler () {
    this.stores = []
    this.storeOffset = 0
    this.selectedStores = []
    this.storeZipCode = ''
    this.storeCity = ''
    if (this.storeId !== '') {
      this.getStoreLocations()
    }
  }

  getNonGeoSurveys () {
    this.$store
      .dispatch('getSurveysList', {
        limit: this.limitPerPage,
        offset: this.surveysOffset,
        brand_id: this.brandId,
        type: 'GEO'
      })
      .then(
        response => {
          this.surveys.push(...response.response.body.surveys)
        },
        response => {}
      )
  }

  getBrandCoupons () {
    this.$store.dispatch('getBrandCoupons', { brandId: this.brandId, limit: 100, offset: 0, type: 'PICKL' }).then(response => {
      this.brandCoupons = response.response.body.coupons
    })
  }
  getLocationCatalogues () {
    this.$store.dispatch('getBrandLocationCatalogueas', { limit: this.limit, offset: this.offset }).then((response: any) => {
      this.tasks.push(...response.response.body.data)
      if (this.tasks.length < response.response.body.count) {
        this.taskOffset += this.taskLimitPerPage
        this.getTaskList()
      }
    })
  }

  checkSurveyAvailibility () {
    if (this.$store.state.settings.enable_survey_feature === '1') {
      if (this.surveyFeatureAvailable === true) {
        this.showSurveyField = true
        this.getNonGeoSurveys()
      } else {
        this.surveyUnavailableMessage = 'Upgrade your plan to use this feature'
      }
    } else {
      this.surveyUnavailableMessage = 'Coming soon! Contact PICKL support for more info.'
    }
  }

  mounted () {
    // console.log(this.localPicklFeature)
  }
  created () {
    this.loadingCredits = true
    this.time.setHours(this.time.getHours() + 1)
    this.$store.dispatch('getBrandCurrentSubscription', this.brandId).then((response) => {
      this.loadingCredits = false
      this.reimbursementCredits = response.response.body.data.reimbursement_credits
    })
    this.getProducts()
    this.$store.dispatch('getAppSettingsKeyValuePair').then(() => {
      this.pickl.pickl_multiple_products = this.$store.state.settings.pickl_multiple_products
      for (var i = 1; i <= this.$store.state.settings.max_extend_counter; i++) {
        this.maxExtendCounter.push(i)
      }
      this.maxExtendDays = this.$store.state.settings.max_extend_days

      this.checkSurveyAvailibility()
    })
    this.getTaskList()
    this.getCountries()
    this.getStates()
    this.getBrandLocationCatalogues()
    this.getBrandCoupons()
    this.getAllRetailers()
    let userData = this.$store.state.userData
    this.userRole = userData.role
  }

  @Watch('pickl.activityType')
  onActivityTypeChange () {
    if (this.pickl.activityType === 'media') {
      if (this.media.length === 0) {
        this.getMedia()
      }
    }
    if (this.pickl.activityType === 'survey') {
      if (this.surveys.length === 0) {
        this.getNonGeoSurveys()
      }
    }
  }
  @Watch('surveyFeatureAvailable')
  onSurveyAvailibilityChange () {
    this.checkSurveyAvailibility()
  }
  @Watch('pickl.multipleResponses')
  onMultipleResponsesChange () {
    this.selectedRetails = []
  }

  @Watch('geoRestricted')
  onGeoRestrictedChange () {
    this.pickl.geoRestricted = this.geoRestricted ? 1 : 0
  }

  @Watch('activityTypes', { deep: true })
  onActivityTypesChange () {
    // Auto-collapse activities when they become valid (only if not manually toggled and not actively editing)
    this.activityTypes.forEach((activity: any, index: number) => {
      // Skip auto-collapse if user has manually toggled this activity
      if (this.manuallyToggledActivities.has(index)) {
        return
      }
      // Skip auto-collapse if user is actively editing (typing in textarea)
      if (this.activelyEditingActivities.has(index)) {
        return
      }
      if (this.isActivityValid(activity) && !activity.collapsed) {
        // Small delay to allow user to see the "Complete" indicator
        setTimeout(() => {
          // Double-check that user hasn't manually toggled or started editing in the meantime
          if (!this.manuallyToggledActivities.has(index) &&
              !this.activelyEditingActivities.has(index) &&
              this.activityTypes[index] &&
              this.isActivityValid(this.activityTypes[index])) {
            this.activityTypes[index].collapsed = true
          }
        }, 1000)
      }
    })
  }

  onVideoDescriptionFocus (index: number) {
    // Mark this activity as actively being edited
    this.activelyEditingActivities.add(index)
  }

  onVideoDescriptionBlur (index: number) {
    // Remove from actively editing set
    this.activelyEditingActivities.delete(index)
    // If the activity is valid, auto-collapse after a short delay
    if (this.activityTypes[index] && this.isActivityValid(this.activityTypes[index]) && !this.manuallyToggledActivities.has(index)) {
      setTimeout(() => {
        if (this.activityTypes[index] &&
            this.isActivityValid(this.activityTypes[index]) &&
            !this.manuallyToggledActivities.has(index) &&
            !this.activelyEditingActivities.has(index)) {
          this.activityTypes[index].collapsed = true
        }
      }, 500)
    }
  }

  onSelfieDescriptionFocus (index: number) {
    // Mark this activity as actively being edited
    this.activelyEditingActivities.add(index)
  }

  onSelfieDescriptionBlur (index: number) {
    // Remove from actively editing set
    this.activelyEditingActivities.delete(index)
    // If the activity is valid, auto-collapse after a short delay
    if (this.activityTypes[index] && this.isActivityValid(this.activityTypes[index]) && !this.manuallyToggledActivities.has(index)) {
      setTimeout(() => {
        if (this.activityTypes[index] &&
            this.isActivityValid(this.activityTypes[index]) &&
            !this.manuallyToggledActivities.has(index) &&
            !this.activelyEditingActivities.has(index)) {
          this.activityTypes[index].collapsed = true
        }
      }, 500)
    }
  }

  onBuyMeDescriptionFocus (index: number) {
    this.activelyEditingActivities.add(index)
  }

  onBuyMeDescriptionBlur (index: number) {
    this.activelyEditingActivities.delete(index)
    if (this.activityTypes[index] && this.isActivityValid(this.activityTypes[index]) && !this.manuallyToggledActivities.has(index)) {
      setTimeout(() => {
        if (this.activityTypes[index] &&
            this.isActivityValid(this.activityTypes[index]) &&
            !this.manuallyToggledActivities.has(index) &&
            !this.activelyEditingActivities.has(index)) {
          this.activityTypes[index].collapsed = true
        }
      }, 500)
    }
  }

  onDealDropDescriptionFocus (index: number) {
    this.activelyEditingActivities.add(index)
  }

  onDealDropDescriptionBlur (index: number) {
    this.activelyEditingActivities.delete(index)
    if (this.activityTypes[index] && this.isActivityValid(this.activityTypes[index]) && !this.manuallyToggledActivities.has(index)) {
      setTimeout(() => {
        if (this.activityTypes[index] &&
            this.isActivityValid(this.activityTypes[index]) &&
            !this.manuallyToggledActivities.has(index) &&
            !this.activelyEditingActivities.has(index)) {
          this.activityTypes[index].collapsed = true
        }
      }, 500)
    }
  }

  onAppWebsiteReviewDescriptionFocus (index: number) {
    this.activelyEditingActivities.add(index)
  }

  onAppWebsiteReviewDescriptionBlur (index: number) {
    this.activelyEditingActivities.delete(index)
    if (this.activityTypes[index] && this.isActivityValid(this.activityTypes[index]) && !this.manuallyToggledActivities.has(index)) {
      setTimeout(() => {
        if (this.activityTypes[index] &&
            this.isActivityValid(this.activityTypes[index]) &&
            !this.manuallyToggledActivities.has(index) &&
            !this.activelyEditingActivities.has(index)) {
          this.activityTypes[index].collapsed = true
        }
      }, 500)
    }
  }

  addTag (newTag: string) {
    this.tags.push(newTag)
    this.filter.values.push(newTag)
  }

  isValidUrl (urlString: string): boolean {
    if (!urlString || urlString.trim() === '') {
      return false
    }
    try {
      const url = new URL(urlString.trim())
      return url.protocol === 'http:' || url.protocol === 'https:'
    } catch (e) {
      return false
    }
  }

  getActivityTypeLabel (type: string) {
    const labels: any = {
      'product': 'Specific Pics',
      'selfie': 'Selfie',
      'photo': 'General Pics',
      // 'video': 'Video Activity',
      'survey': 'Survey',
      'buy-me': 'Reimbursement',
      'deal-drop': 'Deal Drop',
      'watch': 'Watch Media(video/short/story)',
      'url-visit': 'URL Visit (website/giveaway/signup)',
      'app-install': 'App Install (apple/google play)',
      'review': 'Online Review (external link)'
    }
    return labels[type] || type
  }

  getActivityDescription (activity: any) {
    if (activity.type === 'product') {
      const productCount = activity.config.products ? activity.config.products.length : 0
      return `${productCount} product${productCount !== 1 ? 's' : ''} selected`
    } else if (activity.type === 'photo') {
      const taskCount = activity.config.task_ids ? activity.config.task_ids.length : 0
      return `${taskCount} task image${taskCount !== 1 ? 's' : ''} selected`
    // } else if (activity.type === 'video') {
      // return activity.config.videoDescription ? activity.config.videoDescription.substring(0, 50) + (activity.config.videoDescription.length > 50 ? '...' : '') : 'Video activity'
    } else if (activity.type === 'selfie') {
      return activity.config.selfieDescription ? activity.config.selfieDescription.substring(0, 50) + (activity.config.selfieDescription.length > 50 ? '...' : '') : 'Selfie activity'
    } else if (activity.type === 'survey') {
      return 'Survey selected'
    } else if (activity.type === 'buy-me') {
      return activity.config.reimbursementCredits ? `Reimbursement Credits: ${activity.config.reimbursementCredits}` : 'Buy Me Activity'
    } else if (activity.type === 'deal-drop') {
      const selectedCoupon = this.brandCoupons.find((c: any) => c.id === activity.config.couponId)
      return selectedCoupon ? `Coupon: ${selectedCoupon.name}` : 'Deal Drop'
    } else if (activity.type === 'watch') {
      return activity.config.youtubeUrl ? `YouTube: ${activity.config.youtubeUrl.substring(0, 40)}...` : 'Watch Activity'
    } else if (activity.type === 'url-visit') {
      return activity.config.url ? `URL: ${activity.config.url.substring(0, 40)}...` : 'URL Visit'
    } else if (activity.type === 'app-install') {
      const link = this.brandLinks.find((l: any) => String(l.id) === String(activity.config.link_id))
      return link ? (link.title || 'App Install') : 'App Install'
    } else if (activity.type === 'review') {
      const link = this.brandLinks.find((l: any) => String(l.id) === String(activity.config.link_id))
      return link ? (link.title || 'Review') : 'Review'
    }
    return 'Activity configured'
  }

  onDragStart (index: number, event: DragEvent) {
    this.draggedIndex = index
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/html', '')
    }
  }

  onDragOver (event: DragEvent) {
    event.preventDefault()
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move'
    }
  }

  onDragEnter (event: DragEvent) {
    event.preventDefault()
    const target = event.currentTarget as HTMLElement
    if (target) {
      const indexAttr = target.getAttribute('data-index')
      if (indexAttr !== null) {
        const index = parseInt(indexAttr, 10)
        if (!isNaN(index) && index !== this.draggedIndex) {
          this.dragOverIndex = index
        }
      }
    }
  }

  onDragLeave (event: DragEvent) {
    this.dragOverIndex = -1
  }

  onDrop (dropIndex: number, event: DragEvent) {
    event.preventDefault()
    this.dragOverIndex = -1

    if (this.draggedIndex === -1 || this.draggedIndex === dropIndex) {
      this.draggedIndex = -1
      return
    }

    // Reorder activities
    const draggedActivity = this.activityTypes[this.draggedIndex]
    this.activityTypes.splice(this.draggedIndex, 1)
    this.activityTypes.splice(dropIndex, 0, draggedActivity)

    // Update manually toggled activities set with new indices
    const newManuallyToggled = new Set<number>()
    this.manuallyToggledActivities.forEach((oldIndex) => {
      if (oldIndex === this.draggedIndex) {
        newManuallyToggled.add(dropIndex)
      } else if (oldIndex < this.draggedIndex && oldIndex >= dropIndex) {
        newManuallyToggled.add(oldIndex + 1)
      } else if (oldIndex > this.draggedIndex && oldIndex <= dropIndex) {
        newManuallyToggled.add(oldIndex - 1)
      } else {
        newManuallyToggled.add(oldIndex)
      }
    })
    this.manuallyToggledActivities = newManuallyToggled

    // Update actively editing activities set with new indices
    const newActivelyEditing = new Set<number>()
    this.activelyEditingActivities.forEach((oldIndex) => {
      if (oldIndex === this.draggedIndex) {
        newActivelyEditing.add(dropIndex)
      } else if (oldIndex < this.draggedIndex && oldIndex >= dropIndex) {
        newActivelyEditing.add(oldIndex + 1)
      } else if (oldIndex > this.draggedIndex && oldIndex <= dropIndex) {
        newActivelyEditing.add(oldIndex - 1)
      } else {
        newActivelyEditing.add(oldIndex)
      }
    })
    this.activelyEditingActivities = newActivelyEditing

    this.draggedIndex = -1
  }

  addActivityType () {
    if (!this.currentActivityType || this.activityTypes.length >= this.maxActivities) {
      if (this.activityTypes.length >= this.maxActivities) {
        this.$notify({ text: 'You can add maximum 5 activity types', type: 'error' })
      }
      return
    }

    const config: any = {}
    const typeToAdd = this.currentActivityType

    if (typeToAdd === 'product') {
      config.products = [{
        product_id: '',
        description: '',
        task_ids: []
      }]
    } else if (typeToAdd === 'photo') {
      config.task_ids = []
    } else if (typeToAdd === 'video') {
      config.videoDescription = ''
    } else if (typeToAdd === 'selfie') {
      config.selfieDescription = ''
    } else if (typeToAdd === 'survey') {
      config.survey_id = ''
      if (this.surveys.length === 0) {
        this.getNonGeoSurveys()
      }
    } else if (typeToAdd === 'buy-me') {
      config.reimbursementCredits = ''
    } else if (typeToAdd === 'deal-drop') {
      config.couponId = ''
      if (this.brandCoupons.length === 0) {
        this.getBrandCoupons()
      }
    } else if (typeToAdd === 'watch') {
      config.youtubeUrl = ''
      config.description = ''
    } else if (typeToAdd === 'url-visit') {
      config.url = ''
      config.description = ''
    } else if (typeToAdd === 'app-install') {
      config.link_id = null
    } else if (typeToAdd === 'review') {
      config.link_id = null
    }

    this.activityTypes.push({
      type: typeToAdd,
      config: config,
      collapsed: false
    })

    this.currentActivityType = ''
  }

  toggleActivityCollapse (index: number) {
    if (this.activityTypes[index]) {
      this.activityTypes[index].collapsed = !this.activityTypes[index].collapsed
      // Mark this activity as manually toggled to prevent auto-collapse
      this.manuallyToggledActivities.add(index)
    }
  }

  isActivityValid (activity: any) {
    if (activity.type === 'product') {
      if (!activity.config.products || activity.config.products.length === 0) {
        return false
      }
      for (let j = 0; j < activity.config.products.length; j++) {
        const product = activity.config.products[j]
        if (!product.product_id || product.product_id === '') {
          return false
        }
        if (!product.task_ids || product.task_ids.length === 0) {
          return false
        }
      }
      return true
    } else if (activity.type === 'photo') {
      return activity.config.task_ids && activity.config.task_ids.length > 0
    } else if (activity.type === 'video') {
      return activity.config.videoDescription && activity.config.videoDescription.trim() !== ''
    } else if (activity.type === 'selfie') {
      return activity.config.selfieDescription && activity.config.selfieDescription.trim() !== ''
    } else if (activity.type === 'survey') {
      return activity.config.survey_id && activity.config.survey_id !== ''
    } else if (activity.type === 'buy-me') {
      return activity.config.reimbursementCredits && activity.config.reimbursementCredits !== ''
    } else if (activity.type === 'deal-drop') {
      return activity.config.couponId && activity.config.couponId !== ''
    } else if (activity.type === 'watch') {
      return activity.config.youtubeUrl && activity.config.youtubeUrl.trim() !== '' && this.isValidUrl(activity.config.youtubeUrl) && activity.config.description && activity.config.description.trim() !== ''
    } else if (activity.type === 'url-visit') {
      return activity.config.url && activity.config.url.trim() !== '' && this.isValidUrl(activity.config.url) && activity.config.description && activity.config.description.trim() !== ''
    } else if (activity.type === 'app-install') {
      return !!(activity.config.link_id)
    } else if (activity.type === 'review') {
      return !!(activity.config.link_id)
    }
    return false
  }

  removeActivityType (index: number) {
    this.activityTypes.splice(index, 1)
    // Remove from manually toggled set if it exists
    this.manuallyToggledActivities.delete(index)
    // Remove from actively editing set if it exists
    this.activelyEditingActivities.delete(index)
    // Update indices for activities after the removed one
    const newManuallyToggledSet = new Set<number>()
    this.manuallyToggledActivities.forEach((oldIndex: number) => {
      if (oldIndex < index) {
        newManuallyToggledSet.add(oldIndex)
      } else if (oldIndex > index) {
        newManuallyToggledSet.add(oldIndex - 1)
      }
    })
    this.manuallyToggledActivities = newManuallyToggledSet

    const newActivelyEditingSet = new Set<number>()
    this.activelyEditingActivities.forEach((oldIndex: number) => {
      if (oldIndex < index) {
        newActivelyEditingSet.add(oldIndex)
      } else if (oldIndex > index) {
        newActivelyEditingSet.add(oldIndex - 1)
      }
    })
    this.activelyEditingActivities = newActivelyEditingSet
  }

  addProductToActivityType (activityIndex: number) {
    this.activityTypes[activityIndex].config.products.push({
      product_id: '',
      description: '',
      task_ids: []
    })
  }

  removeProductFromActivityType (activityIndex: number, productIndex: number) {
    this.activityTypes[activityIndex].config.products.splice(productIndex, 1)
  }

  setProductImageForActivityType (activityIndex: number, productIndex: number, productId: number) {
    this.products.forEach((product: any) => {
      if (product.id === productId) {
        // Store product image if needed
      }
    })
  }
}
